import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class SideCart extends ThemeComponent {
    @Ref() close!: HTMLDivElement;

    /**
     * Initialise.
     */
    init() {
        this.eventListeners();
    }

    /**
     * Event Listeners
     */
    eventListeners() {
        this.openCart();
        this.closeCart();
        this.closeEvent();
    }

    /**
     * Open Side Cart.
     */
    openCart() {
        document.addEventListener('cartOpen', ()=> {
            this.classList.add('is-active');
            document.body.classList.add('drawer-open', 'drawer-open--cart');
        });
    }

    /**
     * Close Side Cart.
     */
    closeCart() {
        document.addEventListener('cartClosed', ()=> {
            this.classList.remove('is-active');
            document.body.classList.remove('drawer-open', 'drawer-open--cart');
        });
    }

    /**
     * Cart Close click event.
     * @returns
     */
    closeEvent() {
        this.$listen(this, 'click', (event) => {
            const target = event.target as HTMLElement;
            if (target) {
                const isSideCart = target.closest('.side-cart__wrapper');
                const isClose = target == this.close;
                if (!isSideCart || isClose) {
                    document.dispatchEvent(new Event('cartClosed'));
                }
            }

        });
    }
}
